import { HttpError } from '../../config/Axios/axios-instance';
import * as actionTypes from './actionTypes';
import { CompanySubscriptionActionTypes } from './actionTypes';

export interface CompanySubscriptionStateType {
  createCompanySubscriptionPublicLoading: boolean;
  createCompanySubscriptionPublicSuccess: boolean;
  createCompanySubscriptionPublicError: HttpError | null;
  paymentLink: string | null;

  cancelCompanySubscriptionLoading: boolean;
  cancelCompanySubscriptionSuccess: boolean;
  cancelCompanySubscriptionError: HttpError | null;
}

export type CompanySubsciptionActionType = CompanySubscriptionStateType & {
  type: CompanySubscriptionActionTypes;
};

export const initialState: CompanySubscriptionStateType = {
  createCompanySubscriptionPublicLoading: false,
  createCompanySubscriptionPublicSuccess: false,
  createCompanySubscriptionPublicError: null,
  paymentLink: null,

  cancelCompanySubscriptionLoading: false,
  cancelCompanySubscriptionSuccess: false,
  cancelCompanySubscriptionError: null,
};

const createCompanySubscriptionPublicStart = (
  state: CompanySubscriptionStateType,
): CompanySubscriptionStateType => ({
  ...state,
  createCompanySubscriptionPublicLoading: true,
  createCompanySubscriptionPublicSuccess: false,
  createCompanySubscriptionPublicError: null,
  paymentLink: null,
});
const createCompanySubscriptionPublicSuccess = (
  state: CompanySubscriptionStateType,
  action: CompanySubsciptionActionType,
): CompanySubscriptionStateType => ({
  ...state,
  createCompanySubscriptionPublicLoading: false,
  createCompanySubscriptionPublicSuccess: true,
  createCompanySubscriptionPublicError: null,
  paymentLink: action.paymentLink,
});
const createCompanySubscriptionPublicFail = (
  state: CompanySubscriptionStateType,
  action: CompanySubsciptionActionType,
): CompanySubscriptionStateType => ({
  ...state,
  createCompanySubscriptionPublicLoading: false,
  createCompanySubscriptionPublicSuccess: false,
  createCompanySubscriptionPublicError:
    action.createCompanySubscriptionPublicError,
  paymentLink: null,
});

const cancelCompanySubscriptionStart = (
  state: CompanySubscriptionStateType,
): CompanySubscriptionStateType => ({
  ...state,
  cancelCompanySubscriptionLoading: true,
  cancelCompanySubscriptionSuccess: false,
  cancelCompanySubscriptionError: null,
});
const cancelCompanySubscriptionSuccess = (
  state: CompanySubscriptionStateType,
): CompanySubscriptionStateType => ({
  ...state,
  cancelCompanySubscriptionLoading: false,
  cancelCompanySubscriptionSuccess: true,
  cancelCompanySubscriptionError: null,
});
const cancelCompanySubscriptionFail = (
  state: CompanySubscriptionStateType,
  action: CompanySubsciptionActionType,
): CompanySubscriptionStateType => ({
  ...state,
  cancelCompanySubscriptionLoading: false,
  cancelCompanySubscriptionSuccess: false,
  cancelCompanySubscriptionError: action.cancelCompanySubscriptionError,
});

const resetCompanySubscriptionStore = (): CompanySubscriptionStateType => ({
  ...initialState,
});

const reducer = (
  state = initialState,
  action: CompanySubsciptionActionType,
) => {
  switch (action.type) {
    case actionTypes.CREATE_COMPANY_SUBSCRIPTION_PUBLIC_START:
      return createCompanySubscriptionPublicStart(state);
    case actionTypes.CREATE_COMPANY_SUBSCRIPTION_PUBLIC_SUCCESS:
      return createCompanySubscriptionPublicSuccess(state, action);
    case actionTypes.CREATE_COMPANY_SUBSCRIPTION_PUBLIC_FAIL:
      return createCompanySubscriptionPublicFail(state, action);
    case actionTypes.CANCEL_COMPANY_SUBSCRIPTION_START:
      return cancelCompanySubscriptionStart(state);
    case actionTypes.CANCEL_COMPANY_SUBSCRIPTION_SUCCESS:
      return cancelCompanySubscriptionSuccess(state);
    case actionTypes.CANCEL_COMPANY_SUBSCRIPTION_FAIL:
      return cancelCompanySubscriptionFail(state, action);
    case actionTypes.RESET_COMPANY_SUBSCRIPTION_STORE:
      return resetCompanySubscriptionStore();
    default:
      return state;
  }
};

export default reducer;
